import { Collection } from 'modules/core/lib/mobx-rest'

import KomboSupplementSync from 'modules/payroll_integrations_kombo/store/models/SupplementSync'

class KomboSupplementSyncs extends Collection<KomboSupplementSync> {
  get cacheKey(): string {
    return 'komboSupplementSyncs'
  }

  model() {
    return KomboSupplementSync
  }
}

const singleton: KomboSupplementSyncs = new KomboSupplementSyncs()

export default singleton
